// extracted by mini-css-extract-plugin
module.exports = {"plus-header":"style-m__plus-header__3DzG-","vikatan-plus":"style-m__vikatan-plus__3nYCj","vikatan-plus-icon":"style-m__vikatan-plus-icon__lh6Gl"};